import React from 'react';
import { Box, Typography } from '@mui/material';
import HubSectionContainer from '../CustomContainer';

// Shared by the landing grid and the lesson detail page. The prototype renders
// this header outside the list/detail switch, so it stays put when a parent opens
// a lesson and the scroll-away action bar tucks in directly beneath it (QA 3.9).
export default function LessonsHeader() {
  return (
    <>
      <HubSectionContainer wide sx={{ pt: 3, pb: 3 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
          <Typography sx={{
            fontFamily: 'Rasa, serif',
            fontWeight: 500,
            fontSize: '28px',
            lineHeight: 1,
            color: 'rgba(0, 0, 0, 0.87)',
          }}
          >
            Lessons &amp; Guides
          </Typography>
          <Typography variant="body2">
            Practical resources to help you and your pet thrive.
          </Typography>
        </Box>
      </HubSectionContainer>

      <Box sx={{ borderBottom: 1, borderColor: 'divider' }} />
    </>
  );
}
